;(function() {
  'use strict'

  angular.module('core.linkEditorDialog', [])
})()
